import React, { Component } from 'react';
import SsoPage from 'containers/Auth/SSO/SsoPage';
import Verification from 'components/Verification';
import ProcessPage from 'components/ProcessPage';
import { VuiButton } from '@topkamera/viso-ui';

class VerificationCode extends Component {
  state = {
    codes: [],
    activeIndex: 0,
    type: 'code',
  }

  onChange = (e, index) => {
    const value = e.key || e.currentTarget.value;

    this.state.codes[index] = value;
    this.setState({ activeIndex: parseInt(index, 10) + 1 });
    this.setState({ codes: this.state.codes });
  }


  onUpdate = value => this.setState({ codes: value })

  onUpdateOption = () => {
    const activeType = this.state.type;

    if (activeType === 'code') {
      return this.setState({ type: 'recoveryKey' });
    }
    return this.setState({ type: 'code' });
  }

  render() {
    const code = this.state.codes.length && this.state.codes.reduce((sum, item) => `${sum}${item}`);

    return (
      <ProcessPage splitPage={true} customClass='split-page-full-height-popup'>
        {() => (
          <>
            {this.state.showModal && this.renderModal()}
            <SsoPage
              title={this.state.type === 'code' ? 'Verification code' : 'Recovery key'}
              description={this.state.type === 'code' ? 'Please enter the 6-digit code from your phone app.' : 'Please enter your recovery key.'}
            >
              <div className='sso-page-form'>
                <div className='sso-page-field vui-pt-20 vui-pb-40'>
                  <Verification
                    onUpdate={this.onUpdate}
                    codes={this.state.codes}
                    activeIndex={this.state.activeIndex}
                    onChange={this.onChange}
                  />
                </div>
                <div className="sso-page-form__button sso-page-form__button--margin-md sso-page-form__button--270">
                  <VuiButton
                    disabled={code.length !== 6}
                    color='accent0'
                    style='filled'
                    radius='pill'
                    label='Continue'
                    onClick={() => {
                      if (code.length === 6) {
                        this.props.onSubmit(this.state.codes, this.state.type);
                      }
                    }}
                    isBlock
                  />
                </div>
                <div className="vui-text-center vui-body-sm vui-pt-10">
                  <a href='#useKey'
                    className="accent0"
                    onClick={(e) => {
                      e.preventDefault()
                      this.onUpdateOption()
                    }}
                  >
                    {this.state.type === 'code' ? 'Use the recovery key' : 'Use the verification code'}
                  </a>
                </div>
              </div>
            </SsoPage>
          </>
        )}
      </ProcessPage>
    );
  }
}

export default VerificationCode;